// @core/api/endpoints/team/update_team.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update team information
 * Updates team metadata such as name, description, and visibility settings. Requires admin privileges on the team.
 */
export async function UpdateTeam(
  team_id: string,
  data: UpdateTeamRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
